import { DataGate } from '../components/shell/PageBody.tsx';
import { LiveRoom } from '../features/agents/LiveRoom.tsx';

export default function Wall() {
  return <div data-surface="wall" className="fixed inset-0 z-modal overflow-auto bg-canvas p-8 text-lead">
    <h1 className="mb-6 text-display font-medium">Orgus live wall</h1>
    <DataGate><LiveRoom wall /></DataGate>
  </div>;
}
